import { render, staticRenderFns } from "./WarehouseScreenPurchase.vue?vue&type=template&id=40328eaa"
import script from "./WarehouseScreenPurchase.vue?vue&type=script&lang=js"
export * from "./WarehouseScreenPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports